<template>
	<div class="tab-host d-flex flex-column position-relative" :id="`tab-${tabId}`">
		<ul class="tabs-list" tabscope :tabindex="tabindex" ref="tabul" :startup="startup ? true : null">
			<div class="active-tab-indicator"></div>
			<li v-for="(tab, i) in tabs" :key="i" class="tab-item" :tabindex="i + 1">
				<a @click="selectTab(tab.id, $event)" class="tab-link" :class="{ 'active': tab.isActive, 'disabled': tab.isDisabled }" v-html="tab.name" href="javascript:void(0)"></a>
			</li>
		</ul>
		<div :class="{ 'tab-host-panels': true, 'scrollable': scrollable }" ref="tabs-panel">
			<slot />
		</div>
	</div>
</template>
<script>
	import $ from 'jquery'

	export default {
		name: 'stab-host',
		props: {
			activeTab: { default: '' },
			scrollable: { type: Boolean, default: false },
			startup: { type: Boolean },
			tabindex: { type: [String, Number] }
		},
		emits: ['activeTabChanged'],
		data() {
			return {
				tabId: Math.random().toString(32).slice(2, 8),
				tabs: [],
				currentTab: null
			}
		},
		watch: {
			activeTab: {
				handler(value, oldValue) {
					if (value != this.currentTab)
						this.selectTab(value)
				}
			},
		},
		computed: {
		},
		created() {
		},
		mounted() {
			if (this.tabs.length > 0) {
				if (this.activeTab !== '') {
					this.selectTab(this.activeTab)
				} else {
					this.selectTab(this.tabs[0].id)
				}
			}
		},
		methods: {

			findTab(id) {
				return this.tabs.find(tab => tab.id === id)
			},
			selectTab(selectedTabId, event) {
				if (typeof event !== 'undefined') {
					event.preventDefault()
				}

				const selectedTab = this.findTab(selectedTabId)

				if (!selectedTab) {
					return
				}

				if (selectedTab.isDisabled) {
					return
				}

				this.tabs.forEach(tab => {
					tab.isActive = (tab.id === selectedTab.id)
				})

				this.currentTab = selectedTab.id
				this.$emit('activeTabChanged', selectedTab.id)


				// if event != undefined then this called by an click or keydown event
				if (typeof event !== 'undefined') {
					this.focusTab()
				}

				this.defer(() => {


					let activeTab = document.querySelector(`#tab-${this.tabId} > .tabs-list > .tab-item > .tab-link.active`)
					if (activeTab) {
						let bounding = activeTab?.getBoundingClientRect()

						let indicator = document.querySelector(`#tab-${this.tabId} .active-tab-indicator`)
						indicator.style.width = bounding.width + 'px'
						indicator.style.height = bounding.height + 'px'
						indicator.style.top = activeTab.offsetTop + 'px'
						indicator.style.left = activeTab.offsetLeft + 'px'

					}
				}, 1)
			},
			focusTab() {
				var that = this
				setTimeout(() => {
					var tabItems = $(that.$refs['tabs-panel']).find('section:visible [tabindex]').map(function (index, item) {
						return {
							tabindex: parseInt(item.attributes.tabindex.value),
							el: item
						}
					})

					if (tabItems.length > 0) {
						var min = tabItems[0]

						for (var i = 1; i < tabItems.length; i++) {
							if (tabItems[i].tabindex > 0 && tabItems[i].tabindex < min.tabindex) {
								min.el = tabItems[i].el
							}
						}

						if (min.el != null) {
							$(min.el).focus()
						}
					}
				}, 5)
			},
		}
	}
</script>
<style lang="less" scoped>
	.tab-host {
		align-items: flex-start;
		height: 100%;
		overflow: hidden;
	}

	.tabs-list {
		background-color: #e7ecef;
		border-radius: 10px;
		padding: 5px;
		display: inline-flex;
		list-style: none;
		margin-right: auto;
		margin-left: auto;
	}

	.tab-item {
		background-color: transparent;
		color: black;
		min-width: 110px;
		z-index: 4;

		.tab-link {
			color: black;
			text-decoration: none;
			text-align: center;
			display: block;
			border-radius: 8px;
			padding: 8px;
		}
	}

	.active-tab-indicator {
		background: white;
		box-shadow: 0px 1px 3px 0 rgb(0 0 0 / 16%);
		border-radius: 8px;
		transition: all 300ms ease-in-out;
		position: absolute;
		z-index: 2;
	}

	.tab-host-panels {
		width: 100%;
		height: 100%;
		flex-grow: 1;
		min-height: 0;
	}
</style>
